export default __webpack_public_path__ + "static/media/SPEKTRA.85733c59.png";